module.exports = __webpack_public_path__ + "app/assets/images/error.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/error.png
// module id = 299
// module chunks = 7